import { TaskList } from "../components/TaskList";

export function Home() {
  return (
    <div className="ion-padding container">
      <TaskList />
    </div>
  );
}
